import React from "react";
import { setSocialMediaType, useAppDispatch } from "@hypexone/uicore";
import { SocialMediaTypeEnum } from "../../../utils/types/userMenu.types";

interface SocialMediaButtonProps {
  handleButtonClick: () => void;
  iconSrc: string;
  buttonLabel: SocialMediaTypeEnum;
}

const SocialMediaButn: React.FC<SocialMediaButtonProps> = ({
  handleButtonClick,
  iconSrc,
  buttonLabel,
}) => {
  const dispatch = useAppDispatch();

  return (
    <button
      onClick={() => {
        handleButtonClick();
        dispatch(setSocialMediaType(buttonLabel));
      }}
      className="flex bg-[#243A48] items-center justify-center h-[30px] w-fit px-3 gap-2 capitalize rounded-[4px] text-white text-[15px] "
    >
      <img src={iconSrc} alt="social-icon" className="h-[20px] w-[20px]" />
      {buttonLabel?.toLowerCase()}
    </button>
  );
};

export default SocialMediaButn;
